define('WeltPixel_FrontendOptions/js/mute_migrate',[
    'jquery'
], function ($) {
    $.migrateMute = true;
    $.migrateTrace = false;
});

